 <template>
  <div>
    <v-dialog v-model="access_right_dialog" max-width="1000" persistent>
      <v-card :loading="loading">
        <v-card-title class="headline">AccessRights ({{selected_role_data.name}})</v-card-title>
        <v-card-text>
          <v-row dense>
            <v-col cols="12">
              <v-simple-table dense>
                <thead>
                  <tr>
                    <th>Module Name</th>
                    <th>
                      <div class="d-flex">
                        <v-checkbox color="grey darken-1" v-model="readChk" @click="selectUncheckAll('read')" hide-details="" :ripple="false" class="custom-simple-box mt-0 pt-0" dense=""></v-checkbox>Read
                      </div>
                    </th>
                    <th>
                      <div class="d-flex">
                        <v-checkbox color="grey darken-1" v-model="addChk" hide-details="" @click="selectUncheckAll('add')" :ripple="false" class="custom-simple-box mt-0 pt-0" dense=""></v-checkbox>Add
                      </div></th>
                    <th>
                      <div class="d-flex">
                        <v-checkbox color="grey darken-1" v-model="editChk" hide-details="" @click="selectUncheckAll('edit')" :ripple="false" class="custom-simple-box mt-0 pt-0" dense=""></v-checkbox>Edit
                      </div>
                    </th>
                    <th>
                      <div class="d-flex">
                        <v-checkbox color="grey darken-1" v-model="deleteChk" hide-details="" @click="selectUncheckAll('delete')" :ripple="false" class="custom-simple-box mt-0 pt-0" dense=""></v-checkbox>Delete
                      </div>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(row, index) in module_list" :key="index" class="mt-3">
                    <td>
                      {{row.name}}
                    </td>
                    <td>
                      <v-checkbox color="grey darken-1" hide-details="" v-model="row.can_read" :ripple="false" class="custom-simple-box mt-0 pt-0" dense=""></v-checkbox>
                    </td>
                    <td>
                      <v-checkbox color="grey darken-1" hide-details="" v-model="row.can_add" :ripple="false" class="custom-simple-box mt-0 pt-0" dense=""></v-checkbox>
                    </td>
                    <td>
                      <v-checkbox color="grey darken-1" hide-details="" v-model="row.can_edit" :ripple="false" class="custom-simple-box mt-0 pt-0" dense=""></v-checkbox>
                    </td>
                    <td>
                      <v-checkbox color="grey darken-1" hide-details="" v-model="row.can_delete" :ripple="false" class="custom-simple-box mt-0 pt-0" dense=""></v-checkbox>
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn color="error" @click="closeDialog();">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-capitalize"
            @click="updateAccessRight()"
            :loading="loading"
          >Update</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
 </template>
 <script>
 import axios from "../../plugins/axios";
 import { mapMutations } from "vuex";
 export default {
  data() {
    return {
      loading: false,
      readChk: false,
      addChk: false,
      editChk: false,
      deleteChk: false,
      module_list: []
    }
  },
  props: ['access_right_dialog','selected_role_data'],
  watch: {
    access_right_dialog(val) {
      if(val) {
        this.loading = false
        this.readChk = false
        this.addChk = false
        this.editChk = false
        this.deleteChk = false
        this.getModules();
      }
    }
  },
  computed: {
  },
  components: {
  },
   methods: {    
    ...mapMutations("utils", ["setAlert"]),
    selectUncheckAll(flag) {
      this.module_list.map((item) => {
        if(flag == 'read') {
          return item.can_read = this.readChk
        } else if(flag == 'add') {
          return item.can_add = this.addChk
        } else if(flag == 'edit') {
          return item.can_edit = this.editChk
        } else if(flag == 'delete') {
          return item.can_delete = this.deleteChk
        }
      })
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    updateAccessRight() {
      this.loading = true;
      axios
        .post("update_access_right", {data: this.module_list, role_id: this.selected_role_data.role_id})
        .then((response) => {
          if(response.data.status) {
            this.setAlert({
              show: true,
              variant: "primary",
              message: response.data.message,
              dismissCountDown: 0
            });
          }
          this.loading = false;
          this.$emit('closeDialog');
        })
        .catch(function (error) {
          console.log("FAILURE!!", error);
          this.loading = false;
        });
    },
    getModules() {
      this.loading= true;
      axios.get("get_modules?role_id="+this.selected_role_data.role_id)
        .then((response) => {
          this.module_list = response.data.data;
          this.loading = false
        })
        .catch(function () {
          this.loading = false
        });
    }
  },
  created: function() {
  },
  mounted: function () {
  }
 }
 </script>